<template>
  <div class="pt-16">
    <h2 class="pt-6 pb-3">Import Wcg Charge Files</h2>
    <v-container fluid pa-0 ma-0>
      <v-card>
        <v-row no-gutters style="height: 150px" align="center">
          <v-col cols="3" class="pl-4 pr-8">
            <v-menu
              v-model="datepicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="chargeDate"
                  label="Select Charge Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="chargeDate"
                @input="datepicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" class="pl-16">
            <v-file-input
              label="Import file"
              :disabled="chargeDate == null"
              v-model="file"
              @change="processFile"
            ></v-file-input>
          </v-col>
          <v-col>
            <v-btn
              class="primary"
              :disabled="disbleImportBtn"
              @click="importToUb"
              >{{ importBtnLabel }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
      <v-overlay :value="processingImport">
        <v-progress-circular indeterminate color="primary" size="64"
          >Importing...</v-progress-circular
        >
      </v-overlay>
      <v-alert type="success" :value="importDone" text
        >{{ alertMessage }}
      </v-alert>
    </v-container>
    <v-container>
      <v-col cols="3" align="left">
        <span class="subtitle-1 pl-4 pt-4 d-inline-block">Import Summary</span>
      </v-col>
      <v-alert v-if="errorMessage" text type="error">
        {{ errorMessage }}
      </v-alert>
      <v-card>
        <ag-grid-vue
          style="height: 500px"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :defaultColDef="defaultColDef"
          :rowData="rowData"
          :enableCellTextSelection="true"
          :ensureDomOrder="true"
        >
        </ag-grid-vue>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import moment from "moment";
import { HTTP } from "@/http-common";
import parse from "csv-parse";
export default {
  name: "ImportWcgCharge",
  components: {
    AgGridVue,
  },
  data: () => ({
    gridApi: {},
    gridColumnApi: {},
    gridOptions: {},
    defaultColDef: {
      resizable: true,
    },
    columnDefs: null,
    file: null,
    dialog: false,
    rowData: [],
    errorMessage: null,
    fileContents: null,
    importBtnLabel: "Import to UB",
    alertMessage: "",
    disbleImportBtn: true,
    processingImport: false,
    importDone: false,
    datepicker: false,
    chargeDate: null,
  }),
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
    vm.gridApi.sizeColumnsToFit();
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = { defaultToolPanel: "" };
    vm.columnDefs = [
      {
        headerName: "Service Number",
        field: "ServiceNumber",
        sortable: true
      },
      {
        headerName: "Charge Description",
        field: "Details",
        sortable: true
      },
      {
        headerName: "Charge",
        field: "Charge",
        sortable: true
      },
      {
        headerName: "Charge Type",
        field: "ChargeType",
        sortable: true
      },
      {
        headerName: "Start Date",
        field: "DateFrom",
        sortable: true
      },
    ];
  },
  methods: {
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
      vm.gridApi.sizeColumnsToFit();
    },
    processFile() {
      this.importDone = false;
      if (this.file != null) {
        this.disbleImportBtn = true;
        this.importBtnLabel = "Processing file...";
        this.readCSV();
        this.upload();
      }
    },
    parseCSV() {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        let vm = this;
        reader.readAsText(this.file);
        reader.onload = (e) => {
          parse(
            reader.result,
            { columns: true, skip_empty_lines: true },
            function(err, output) {
              if (err) {
                vm.errorMessage = err;
                reject(err);
              } else {
                // vm.rowData = output;
                resolve(output);
              }
            }
          );
        };
      });
    },
    async readCSV() {
      let vm = this;
      if (!vm.file.name.toLowerCase().includes("csv")) {
        return;
      }
      try {
        this.fileContents = await this.parseCSV();
        this.columnDefs = [
          {
            headerName: "Service Number",
            field: "ServiceNumber",
            sortable: true
          },
          {
            headerName: "Charge Description",
            field: "Details",
            sortable: true
          },
          {
            headerName: "Charge",
            field: "Charge",
            sortable: true
          },
          {
            headerName: "Charge Type",
            field: "ChargeType",
            sortable: true
          },
          {
            headerName: "Start Date",
            field: "DateFrom",
            sortable: true
          },
        ];
      } catch (error) {
        this.errorMessage = error;
      }
    },
    async upload() {
      let vm = this;
      this.errorMessage = null;
      let formData = new FormData();
      if (vm.file.name.toLowerCase().includes("csv")) {
        vm.fileContents = await this.parseCSV();
      }

      formData.append("file", this.file);
      formData.append("chargeDate", this.chargeDate);
      this.importFile(formData)
        .then((data) => {
          this.rowData = data.data;
          this.rowData.forEach((d) => {
            d.chargeDate = moment(d.chargeDate).format("MMM D, YYYY");
          });
          this.gridApi.hideOverlay();
          this.importBtnLabel = "Import to UB";
          this.disbleImportBtn = false;
          this.gridApi.sizeColumnsToFit();
        })
        .catch((err) => {
          this.errorMessage = err.response.data.message;
          this.gridApi.hideOverlay();
        });
    },
    importFile(formData) {
      let vm = this;
      this.gridApi.showLoadingOverlay();
      return new Promise((resolve, reject) => {
        let response = HTTP.post("BulkUpload/filterChargeRecords", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        response
          .then((data) => {
            vm.columnDefs = [
              {
                headerName: "Service Number",
                field: "serviceNumber",
                sortable: true
              },
              {
                headerName: "Charge Description",
                field: "details",
                sortable: true
              },
              {
                headerName: "Charge",
                field: "charge",
                sortable: true
              },
              {
                headerName: "Charge Type",
                field: "chargeType",
                sortable: true
              },
              {
                headerName: "Start Date",
                field: "dateFrom",
                sortable: true
              },
            ];
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    importToUb() {
      this.disbleImportBtn = true;
      this.processingImport = true;
      this.importRecords(this.rowData)
        .then((data) => {
          this.file = null;
          this.alertMessage =
            "Import done. " + data.data.length + " rows imported.";
          this.processingImport = false;
          this.importDone = true;
          this.chargeDate = null;
          this.rowData = data.data;
          this.rowData.forEach((d) => {
            d.chargeDate = moment(d.chargeDate).format("MMM D, YYYY");
          });
          this.gridApi.hideOverlay();
          this.importBtnLabel = "Result";
          this.gridApi.sizeColumnsToFit();
        })
        .catch((err) => {
          this.errorMessage = err.response.data.message;
          this.gridApi.hideOverlay();
        });
    },
    importRecords(records) {
      let vm = this;
      this.gridApi.showLoadingOverlay();
      return new Promise((resolve, reject) => {
        let response = HTTP.post("BulkUpload/importWcgCharges", records, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        });
        response
          .then((data) => {
            vm.columnDefs = [
              {
                headerName: "Service Number",
                field: "serviceNumber",
                sortable: true
              },
              {
                headerName: "Charge Description",
                field: "details",
                sortable: true
              },
              {
                headerName: "Charge",
                field: "charge",
                sortable: true
              },
              {
                headerName: "Charge Type",
                field: "chargeType",
                sortable: true
              },
              {
                headerName: "Start Date",
                field: "dateFrom",
                sortable: true
              },
              {
                headerName: "Success",
                field: "success",
                sortable: true
              },
              {
                headerName: "Reason",
                field: "reason",
                sortable: true
              },
            ];
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>

<style lang="scss">
  .ag-font-style {
    user-select: initial;
    -moz-user-select: text;
    -ms-user-select: text;
    -webkit-user-select: text;
  }
</style>
